// Оптимизатор Next не передаёт авторизацию: разрешаем только известные публичные пути.
export function canOptimizePublicImage(src: string): boolean {
  if (!src.startsWith('/') || src.startsWith('//') || src.includes('\\')) return false;
  try {
    const url = new URL(src, 'https://local.invalid');
    const pathname = decodeURIComponent(url.pathname);
    if (pathname.includes('..') || pathname.includes('\\')) return false;
    return /\.(?:jpe?g|png|webp|avif)$/i.test(pathname)
      && (pathname.startsWith('/assets/') || pathname.startsWith('/uploads/news_covers/'));
  } catch {
    return false;
  }
}
